module.exports = __webpack_public_path__ + "static/media/chart3.8719bce8.png";